export const GET_EMAIL_API_SETTINGS_REQ = 'GET_EMAIL_API_SETTINGS_REQ';
export const GET_EMAIL_API_SETTINGS_SUCCESS = 'GET_EMAIL_API_SETTINGS_SUCCESS';
export const GET_EMAIL_API_SETTINGS_FAIL = 'GET_EMAIL_API_SETTINGS_FAIL';

export const SAVE_TOMBA_SETTINGS_REQ = 'SAVE_TOMBA_SETTINGS_REQ';
export const SAVE_TOMBA_SETTINGS_SUCCESS = 'SAVE_TOMBA_SETTINGS_SUCCESS';
export const SAVE_TOMBA_SETTINGS_FAIL = 'SAVE_TOMBA_SETTINGS_FAIL';

export const SAVE_HUNTER_SETTINGS_REQ = 'SAVE_HUNTER_SETTINGS_REQ';
export const SAVE_HUNTER_SETTINGS_SUCCESS = 'SAVE_HUNTER_SETTINGS_SUCCESS';
export const SAVE_HUNTER_SETTINGS_FAIL = 'SAVE_HUNTER_SETTINGS_FAIL';

export const SAVE_ABSTRACT_SETTINGS_REQ = 'SAVE_ABSTRACT_SETTINGS_REQ';
export const SAVE_ABSTRACT_SETTINGS_SUCCESS = 'SAVE_ABSTRACT_SETTINGS_SUCCESS';
export const SAVE_ABSTRACT_SETTINGS_FAIL = 'SAVE_ABSTRACT_SETTINGS_FAIL';

export const SAVE_SHEET_SETTINGS_REQ = 'SAVE_SHEET_SETTINGS_REQ';
export const SAVE_SHEET_SETTINGS_SUCCESS = 'SAVE_SHEET_SETTINGS_SUCCESS';
export const SAVE_SHEET_SETTINGS_FAIL = 'SAVE_SHEET_SETTINGS_FAIL';

// export const SAVE_PRE_SHEET_SETTINGS_REQ = 'SAVE_PRE_SHEET_SETTINGS_REQ';
// export const SAVE_PRE_SHEET_SETTINGS_SUCCESS =
// 	'SAVE_PRE_SHEET_SETTINGS_SUCCESS';
// export const SAVE_PRE_SHEET_SETTINGS_FAIL = 'SAVE_PRE_SHEET_SETTINGS_FAIL';

export const SAVE_WEBHOOK_SETTINGS_REQ = 'SAVE_WEBHOOK_SETTINGS_REQ';
export const SAVE_WEBHOOK_SETTINGS_SUCCESS = 'SAVE_WEBHOOK_SETTINGS_SUCCESS';
export const SAVE_WEBHOOK_SETTINGS_FAIL = 'SAVE_WEBHOOK_SETTINGS_FAIL';

export const GET_WEBHOOK_SETTINGS_REQ = 'GET_WEBHOOK_SETTINGS_REQ';
export const GET_WEBHOOK_SETTINGS_SUCCESS = 'GET_WEBHOOK_SETTINGS_SUCCESS';
export const GET_WEBHOOK_SETTINGS_FAIL = 'GET_WEBHOOK_SETTINGS_FAIL';

export const GET_SHEET_SETTINGS_REQ = 'GET_SHEET_SETTINGS_REQ';
export const GET_SHEET_SETTINGS_SUCCESS = 'GET_SHEET_SETTINGS_SUCCESS';
export const GET_SHEET_SETTINGS_FAIL = 'GET_SHEET_SETTINGS_FAIL';

export const DEL_WEBHOOK_REQ = 'DEL_WEBHOOK_REQ';
export const DEL_WEBHOOK_SUCCESS = 'DEL_WEBHOOK_SUCCESS';
export const DEL_WEBHOOK_FAIL = 'DEL_WEBHOOK_FAIL';

export const DEL_SHEET_REQ = 'DEL_SHEET_REQ';
export const DEL_SHEET_SUCCESS = 'DEL_SHEET_SUCCESS';
export const DEL_SHEET_FAIL = 'DEL_WEBHOOK_FAIL';
